import script from "./goRinSyo0011.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0011.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0011.vue?vue&type=style&index=0&id=431eb445&lang=scss"

const __exports__ = script;

export default __exports__